import {Component, Input} from '@angular/core';
import {UserCardContentRequest} from "../../interface/userCardContentRequest";
import {ContentService} from "../../service/content.service";
import {ContentType} from "../../interface/contentType";

@Component({
  selector: 'app-card-live-preview',
  templateUrl: './card-live-preview.component.html',
  styleUrl: './card-live-preview.component.scss'
})
export class CardLivePreviewComponent {

  @Input() backgroundImage: string | File | null = '/assets/images/defBackgroundImage.png';
  @Input() profilePicture: string | File | null = '/assets/svg/defaultUserIcon.svg';
  @Input() companyLogo: string | File | null = null;
  @Input() fullName = '';
  @Input() description = '';
  @Input() location = '';
  @Input() specialization = '';
  @Input() company = '';
  @Input() hashtagsList: { id: number, name: string }[] = [];
  @Input() contentList: UserCardContentRequest[] = [];
  @Input() isContentViewGrid: boolean = false;
  @Input() isSingleLink: boolean = false;

  content: UserCardContentRequest | undefined;

  constructor(
    private contentService: ContentService
  ) {
  }

  get isContentContainsDocument(): boolean {
    let response: boolean = false;
    this.contentList.forEach(content => {
      if(content.type == ContentType.DOCUMENT && content.active)
        response = true;
    })
    return response;
  }

  get contentWithoutDocument(){
    return this.contentList.filter(content => content.type != ContentType.DOCUMENT);
  }

  get documentName() {
    const document: UserCardContentRequest | undefined = this.contentList.find(content => content.type == ContentType.DOCUMENT);
    if(!document) return "";
    return document.linkTitle ? document.linkTitle : document.contentName;
  }

  showSingleContentLinkOrFirstContent() {
    const foundContent = this.contentList.find(content => content.singleLink);

    if (foundContent) {
      this.content = foundContent;
    } else {
      const firstContent = this.contentList.find(content => content.type != ContentType.DOCUMENT && content.active);
      if(!firstContent) return;
      firstContent.singleLink = true;
      this.content = firstContent;
    }

    return this.content;
  }

  getContentIcon(image: string) {
    return this.contentService.getImage(image)
  }
}
